export function getLineHeight(element) {
  var style = window.getComputedStyle(element, null);
  var lineHeight = style.getPropertyValue('line-height');

  if (lineHeight === 'normal') {
    // Create a temp element to get line-height
    var dom = document.createElement('span');
    dom.style.width = '300px';
    dom.style.position = 'absolute';
    dom.style.visibility = 'hidden';
    dom.innerText = 'Test';
    element.appendChild(dom);
    var height = dom.clientHeight;
    element.removeChild(dom);
    return height;
  }

  return parseFloat(lineHeight);
}

function createSpan(text, className) {
  if (className === void 0) {
    className = '';
  }

  var span = document.createElement('span');
  span.className = className;
  span.textContent = text;
  return span;
}

export function wrapTextChildNodesWithSpan(node, className) {
  if (className === void 0) {
    className = '';
  }

  if (node.nodeType === Node.TEXT_NODE) {
    if (node.textContent) {
      var _node$parentNode;

      (_node$parentNode = node.parentNode) == null ? void 0 : _node$parentNode.replaceChild(createSpan(node.textContent, className), node);
    }
  } else {
    node.childNodes.forEach(function (item) {
      wrapTextChildNodesWithSpan(item, className);
    });
  }
}